<template>
  <div>
    <section-page
      :title="stateLabel + ' Statuses and Automation'"
      :description="description"
    >
      <template v-slot:right>
        <button-outlined icon-left="plus" @click="$refs.createStatusModal.open({state: state})">
          New {{ stateLabel }} Status
        </button-outlined>
      </template>

      <table-default
        :table-data="statuses"
        default-sort="order"
        empty-message="You don't have any statuses.<br>Why don't you make one."
      >
        <b-table-column label="Order" field="order" width="80" v-slot="props">
          {{ props.index + 1 }}
        </b-table-column>

        <b-table-column label="Name" field="label" v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Automations" width="120" numeric centered v-slot="props">
          {{ props.row.automation_count }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="120" v-slot="props">
          <button-link @click="$refs.editStatusModal.open(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>
    </section-page>

    <modal-container>
      <modal-crud-form
        ref="createStatusModal"
        :title="stateLabel + ' Status'"
        form-component="status-form"
      ></modal-crud-form>

      <status-edit-modal ref="editStatusModal"></status-edit-modal>
    </modal-container>
  </div>
</template>

<script>
import StatusEditModal from "./edit-status/StatusEditModal";
import {ENUMS} from "../../../services/enums";
export default {
  name: "PipelineStatusSection",
  components: {StatusEditModal},
  props: {
    statuses: {
      type: Array,
      required: true,
    },
    state: {
      type: Number,
      required: true,
    },
    description: String,
    showChangeByColumn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stateLabel() {
      return this.$utils.newGetEnumLabel(this.state, ENUMS.StatusStateEnum);
    }
  },
};
</script>
